import { lazy } from 'react';

const SetPassword = lazy(() =>
  import(/* webpackChunkName: "SetPassword" */ '@common2/Authorization/SetPassword/SetPassword')
);

export default SetPassword;
